export default __webpack_public_path__ + "static/media/q1_step1_3.ee12bd67.png";